import { CSSProperties, SVGProps } from 'react'
import Colors from 'modules/Colors'

interface GoogleFlatIconProps extends SVGProps<SVGSVGElement> {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const GoogleFlatIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 40,
    onClick
}: GoogleFlatIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            onClick={onClick}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33.44 20.318C33.44 19.3253 33.3509 18.3707 33.1855 17.4544H20V22.8698H27.5345C27.21 24.6198 26.2236 26.1025 24.7409 27.0953V30.608H29.2655C31.9127 28.1707 33.44 24.5816 33.44 20.318Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 33.9999C23.78 33.9999 26.9491 32.7463 29.2655 30.6081L24.741 27.0954C23.4873 27.9354 21.8837 28.4318 20 28.4318C16.3537 28.4318 13.2673 25.969 12.1664 22.6599H7.48914V26.2872C9.79277 30.8627 14.5273 33.9999 20 33.9999Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.1664 22.6601C11.8864 21.8201 11.7273 20.9228 11.7273 20.0001C11.7273 19.0774 11.8864 18.1801 12.1664 17.3401V13.7128H7.48909C6.54091 15.6028 6 17.741 6 20.0001C6 22.2592 6.54091 24.3974 7.48909 26.2874L12.1664 22.6601Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 11.5682C22.0555 11.5682 23.901 12.2745 25.3519 13.6618L29.3673 9.64636C26.9428 7.38727 23.7737 6 20 6C14.5273 6 9.79277 9.13727 7.48914 13.7127L12.1664 17.34C13.2673 14.0309 16.3537 11.5682 20 11.5682Z"
                fill={color}
            />
        </svg>
    )
}

export default GoogleFlatIcon
